// src/services/company.service.js
import AuthService from './auth.service';

class CompanyService {
  async getCompanies(skip = 0, limit = 1000, showAll = true) {
    let url = `/companies?skip=${skip}&limit=${limit}`;
    
    // Adiciona o parâmetro show_all se for true
    if (showAll) {
      url += '&show_all=true';
    }
    
    return await AuthService.makeRequest({
      url: url,
      method: 'GET'
    });
  }

  async getCompany(id) {
    return await AuthService.makeRequest({
      url: `/companies/${id}`,
      method: 'GET'
    });
  }

  async getCompanyPrefs(id) {
    return await AuthService.makeRequest({
      url: `/companies/${id}/prefs`,
      method: 'GET'
    });
  }

  async createCompany(data, planId) {
    console.log('Dados recebidos para criar empresa:', data); // Debug
  
    
  
    return await AuthService.makeRequest({
      url: `/companies?plan_id=${planId}`,
      method: 'POST',
      data: data
    });
  }


  async updateCompany(id, data) {
    console.log('Dados enviados para atualização:', data);  // Debug
  
    // Envia todos os dados necessários diretamente
    const updateData = {
      // Dados do usuário
      email: data.email,
      username: data.username,
      password: data.password,  // Adicionado aqui
      
      // Dados da empresa
      name: data.name,
      whatsapp: data.whatsapp,
      cnpjcpf: data.cnpjcpf,  // Note que é cnpjcpf aqui, não cnpj
      logradouro: data.logradouro,
      numero: data.numero,
      complemento: data.complemento,
      bairro: data.bairro,
      cidade: data.cidade,
      uf: data.uf,
      cep: data.cep,
      plan: data.plan
    };

    // Se não tiver senha, remove o campo
    if (!data.password) {
      delete updateData.password;
    }
  
    return await AuthService.makeRequest({
      url: `/companies/${id}`,
      method: 'PUT',
      data: updateData  // Envia os dados sem aninhar em company/user
    });
  }

  async updatePrefs(id, data) {
    return await AuthService.makeRequest({
      url: `/companies/${id}/prefs`,
      method: 'PUT',
      data
    });
  }

  async uploadLogo(id, file) {
    const formData = new FormData();
    formData.append('logo', file);
    
    return await AuthService.makeRequest({
      url: `/companies/${id}/logo`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }

  async getBranches(id) {
    return await AuthService.makeRequest({
      url: `/companies/${id}/branches`,
      method: 'GET'
    });
  }

  async createBranch(id, data) {
    return await AuthService.makeRequest({
      url: `/companies/${id}/branches`,
      method: 'POST',
      data
    });
  }

  async updateBranch(companyId, branchId, data) {
    return await AuthService.makeRequest({
      url: `/companies/${companyId}/branches/${branchId}`,
      method: 'PUT',
      data
    });
  }

  async deleteBranch(companyId, branchId) {
    return await AuthService.makeRequest({
      url: `/companies/${companyId}/branches/${branchId}`,
      method: 'DELETE'
    });
  }

  // Em company.service.js
async getBranch(companyId, branchId) {
    return await AuthService.makeRequest({
      url: `/companies/${companyId}/branches/${branchId}`,
      method: 'GET'
    });
  }


  async generateSlug() {
    return await AuthService.makeRequest({
      url: '/generate-slug',
      method: 'GET'
    });
  }
}

export default new CompanyService();